import React from 'react';

const SvgActions8 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 18 18" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M16 4H2V2h14zm-3.12 7.32l-3.535 3.53a.48.48 0 0 1-.7 0L5.11 11.32a.51.51 0 0 1 0-.71l.21-.21a.5.5 0 0 1 .35-.14h1.327V6.5a.5.5 0 0 1 .5-.5h2.996a.5.5 0 0 1 .5.5v3.76h1.328a.5.5 0 0 1 .35.14l.21.21a.51.51 0 0 1 0 .71zM16 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions8 svgRef={ref} {...props} />);
export default ForwardRef;
